import React from "react";
import { useTranslation } from "react-i18next";

const FlightsTableHeader = () => {
  const { t } = useTranslation();

  return (
    <thead>
      <tr>
        <th>{t("bookingDetails.flights.date")}</th>
        <th>{t("bookingDetails.flights.from")}</th>
        <th>{t("bookingDetails.flights.to")}</th>
        <th>{t("bookingDetails.flights.Airline")}</th>
        <th>{t("bookingDetails.flights.flightNumber")}</th>
        <th>{t("bookingDetails.flights.departure")}</th>
        <th>{t("bookingDetails.flights.arrival")}</th>
        <th>{t("bookingDetails.flights.freeLuggage")}*</th>
      </tr>
    </thead>
  );
};

export default FlightsTableHeader;
